import moment from "moment";
import store from "../store";

const formatTime = (time, format = "MMM DD, YYYY") => {
  try {
    return moment(time, "YYYY-MM-DDTHH:mm").format(format);
  } catch (e) {
    return "Invalid time";
  }
};

const formatBytes = (bytes) => {
  const kb = 1024;
  let memory = null;

  // kb * kb / 2 = 524288
  if (bytes <= 524288) {
    memory = (bytes / kb).toFixed(2);
    memory = Math.round(memory * 10) / 10;
    return `${memory}KB`;
  }

  // kb * kb * kb / 2 = 536870912
  if (bytes <= 536870912) {
    // kb * kb = 1048576
    memory = (bytes / 1048576).toFixed(2);
    memory = Math.round(memory * 10) / 10;
    return `${memory}MB`;
  }

  // kb * kb * kb = 1073741824
  memory = (bytes / 1073741824).toFixed(2);
  memory = Math.round(memory * 10) / 10;
  return `${memory}GB`;
};

const formatComment = (content, members = []) => {
  for (let i = 0; i < members.length; i++) {
    let name = members[i].name;

    content = content.replaceAll("@" + name, ' <span class="tag-mention">@' + name + "</span> ");
  }
  return content;
};

const extractMentions = (comment, members = []) => {
  let data = [];
  members.forEach((member) => {
    if (comment.includes("@" + member.name)) {
      let id = parseInt(member.id);
      if (!data.includes(id)) {
        data.push(id);
      }
    }
  });
  return data;
};

const getBrowser = () => {
  var ua = navigator.userAgent,
    tem,
    M = ua.match(/(opera|chrome|safari|firefox|msie|trident(?=\/))\/?\s*(\d+)/i) || [];
  if (/trident/i.test(M[1])) {
    tem = /\brv[ :]+(\d+)/g.exec(ua) || [];
    return { name: "IE", version: tem[1] || "" };
  }
  if (M[1] === "Chrome") {
    tem = ua.match(/\bOPR|Edge\/(\d+)/);
    if (tem != null) {
      return { name: "Opera", version: tem[1] };
    }
  }
  M = M[2] ? [M[1], M[2]] : [navigator.appName, navigator.appVersion, "-?"];
  if ((tem = ua.match(/version\/(\d+)/i)) != null) {
    M.splice(1, 1, tem[1]);
  }

  return M.join(" ");
};

const copyClipboard = (text) => {
  var textArea = document.createElement("textarea");
  textArea.style.position = "fixed";
  textArea.style.top = 0;
  textArea.style.left = 0;
  textArea.style.width = "2em";
  textArea.style.height = "2em";

  textArea.style.padding = 0;

  textArea.style.border = "none";
  textArea.style.outline = "none";
  textArea.style.boxShadow = "none";

  textArea.style.background = "transparent";

  textArea.value = text;

  document.body.appendChild(textArea);
  textArea.focus();
  textArea.select();

  try {
    var successful = document.execCommand("copy");
    this.copyMsg = successful ? "Copied" : "Error";
  } catch (err) {}

  document.body.removeChild(textArea);
};

const external_link = (() => {
  let link = process.env.VUE_APP_EXTERNAL_LINK;
  if (link != "https://tryconnect.io") link = location.origin;
  return link;
})();

const is_internal_weezly = (() => {
  return ["http://localhost:9090", "https://dev.tryconnect.io", "https://app.tryconnect.io"].includes(location.origin);
})();

const isValidUrl = (url) => {
  try {
    new URL(url);
    return true;
  } catch {
    return false;
  }
};

export { formatTime, formatBytes, formatComment, extractMentions, getBrowser, copyClipboard, isValidUrl, external_link, is_internal_weezly };
